(function () {
  'use strict';

  if (window.BKFreeShippingBar) {
    window.BKFreeShippingBar.scan();
    return;
  }

  const thresholdDefault = 200000;
  let refreshTimer = 0;
  let refreshController = null;

  function formatMoney(cents, format, arabic) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        const value = Shopify.formatMoney(cents, format || window.money_format || 'EGP {{amount_no_decimals}}');
        return arabic ? value.replace(/LE|EGP/g, 'جنيه') : value.replace(/ج\.م|\bLE\b/g, 'EGP');
      }
    } catch (error) {}
    return arabic
      ? `${Math.round(cents / 100).toLocaleString('ar-EG')} جنيه`
      : `EGP ${Math.round(cents / 100).toLocaleString('en-US')}`;
  }

  function isArabic(element) {
    return (element.dataset.locale || '').toLowerCase().startsWith('ar') || document.documentElement.lang.toLowerCase().startsWith('ar');
  }

  function updateElement(element, cart) {
    const threshold = Number.parseInt(element.dataset.threshold || thresholdDefault, 10);
    const total = Number.parseInt(cart?.total_price ?? element.dataset.cartTotal ?? 0, 10);
    const remaining = Math.max(threshold - total, 0);
    const percentage = threshold > 0 ? Math.min(100, Math.round((total / threshold) * 100)) : 100;
    const arabic = isArabic(element);

    element.dataset.cartTotal = String(total);
    element.style.setProperty('--bk-free-shipping-progress', `${percentage}%`);
    element.classList.toggle('is-complete', remaining === 0);
    element.querySelector('[role="progressbar"]')?.setAttribute('aria-valuenow', String(percentage));

    const message = element.querySelector('[data-bk-free-shipping-message]');
    if (!message) return;
    message.innerHTML = remaining === 0
      ? (arabic ? 'لقد حصلتِ على الشحن المجاني.' : 'You’ve unlocked free shipping.')
      : (arabic
        ? `أضيفي منتجات بقيمة <strong>${formatMoney(remaining, element.dataset.moneyFormat, true)}</strong> للحصول على الشحن المجاني.`
        : `You’re <strong>${formatMoney(remaining, element.dataset.moneyFormat, false)}</strong> away from free shipping.`);
  }

  function updateAll(cart) {
    if (Number.isInteger(cart?.item_count) && cart.item_count >= 0) {
      document.querySelectorAll('.qi-cart [data-cart-count]').forEach((badge) => {
        badge.textContent = cart.item_count < 100 ? String(cart.item_count) : '99+';
        badge.hidden = cart.item_count === 0;
      });
    }
    document.querySelectorAll('[data-bk-free-shipping-bar]').forEach((element) => updateElement(element, cart));
  }

  async function refresh() {
    if (!document.querySelector('[data-bk-free-shipping-bar]')) return;
    refreshController?.abort();
    refreshController = new AbortController();
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {
        credentials: 'same-origin',
        signal: refreshController.signal
      });
      if (!response.ok) throw new Error(`Cart refresh failed with ${response.status}`);
      updateAll(await response.json());
    } catch (error) {
      if (error.name !== 'AbortError') updateAll(null);
    }
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 120);
  }

  function handleCartEvent(event) {
    const cart = event.detail?.cart || event.detail;
    if (cart && typeof cart.total_price === 'number') updateAll(cart);
    else scheduleRefresh();
  }

  function scan() {
    document.querySelectorAll('[data-bk-free-shipping-bar]').forEach((element) => updateElement(element, null));
  }

  document.addEventListener('cart-update', handleCartEvent);
  document.addEventListener('cart:updated', handleCartEvent);
  document.addEventListener('cart:refresh', scheduleRefresh);
  document.addEventListener('bk:cart-updated', handleCartEvent);
  document.addEventListener('change', (event) => {
    if (event.target.closest?.('[data-cart-quantity], cart-items, [data-cart]')) scheduleRefresh();
  });
  document.addEventListener('shopify:section:load', scheduleRefresh);

  window.BKFreeShippingBar = { refresh, scan, update: updateAll };
  scan();
  scheduleRefresh();
})();
